import axios from "axios";
import { useMutation } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const changeFactorMainStatus = async (data: ChangeFactorMainStatusReqT) =>
  axios.post(Routes.CHANGE_FACTOR_MAIN_STATUS, data);

export const useChangeFactorMainStatus = () =>
  useMutation({
    mutationKey: [Keys.CHANGE_FACTOR_MAIN_STATUS_MUT],
    mutationFn: changeFactorMainStatus,
  });
